import type { ValueOf } from 'Types';

export enum Loaders {
  NONE = 'none',
  NORMAL = 'normal',
  CUSTOM = 'custom',
  SMALL = 'small',
  AVATAR_PLACEHOLDER = 'avatar_placeholder',
  INSTAGRAM = 'instagram',
}

export enum ErrorPlaceholders {
  AVATAR = 'avatar',
  INSTAGRAM = 'instagram',
}

export type ImageLoaderType = ValueOf<typeof Loaders>;
export type ImageErrorPlaceholderType = ValueOf<typeof ErrorPlaceholders>;
